import { jsx as _jsx } from "preact/jsx-runtime";
import { TopLevelEditSection } from '../panels/TopLevelEditSection';
export function WebSettingsTab({ web, onPatchWeb, clientCompanyId, workspaceId, campaignId }) {
    return (_jsx("div", { className: "space-y-6", children: _jsx(TopLevelEditSection, { web: web, onPatchWeb: onPatchWeb, clientCompanyId: clientCompanyId, workspaceId: workspaceId, campaignId: campaignId }) }));
}
